export default [
  "Decubitus",
  "Abszess",
  "Bakerzyste",
  "Carotisstenose",
  "Dammriss",
  "Ebola",
  { value: "Facettensyndrom", area: "torso-back" },
  "Gallenblasenentzündung",
  "Hagelkorn",
  "Impetigo contagiosa (Borkenflechte)",
  "Japanische Enzephalitis",
  "Kardiomyopathie",
  "Laktoseintoleranz",
  "Madenwürmer",
  { value: "Nabelbruch", area: "torso-front" },
  "Ornithose",
  "Panikstörung",
  "Q-Fieber",
  "Rabies",
  "Salmonellenvergiftung",
  { value: "Tarsaltunnelsyndrom", hasSides: true, area: "foot-{side}-top" },
  "Ulcus cruris",
  "Varikozele",
  "Wachstumshormonmangel",
  "Achalasie",
  "Bakterielle Vaginose",
  "CFS",
  "Darmkrebs",
  "Echinokokkose",
  "Fadenwürmer",
  "Gallensteine",
  { value: "Hallux rigidus", hasSides: true, area: "foot-{side}-top" },
  "Impingement Syndrom",
  "Juvenile idiopathische Arthritis",
  "Lambert-Eaton-Syndrom",
  { value: "Magen-Darm-Grippe", area: "torso-front" },
  "Nachtblindheit",
  "Osteoporose",
  "Pankreasinsuffizienz",
  "Quallenstich",
  { value: "Rachenentzündung", area: "head-front" },
  "Sarkoidose",
  "Taubheit",
  "Ulcus molle",
  "Vaskulitis",
  "Warzen",
  { value: "Achillodynie", hasSides: true, area: "foot-{side}-back" },
  "Balanitis",
  "Chagas-Krankheit",
  "Darmpolypen",
  "EHEC",
  "Faktor-V-Leiden",
  "Gasbrand",
  { value: "Hallux valgus", hasSides: true, area: "foot-{side}-top" },
  "Insektengiftallergie",
  "Karotisstenose",
  "Larva migrans cutanea und Hakenwurmkrankheit",
  { value: "Magengeschwür", area: "torso-front" },
  "Nagelbettentzündung",
  "Otosklerose",
  "Papageienkrankheit",
  "Rachitis und Osteomalazie",
  "SARS",
  { value: "Tennisarm", hasSides: true, area: "arm-{side}-front" },
  "Urtikaria",
  "Vegetative Dystonie",
  "Weitsichtigkeit",
  "Zeckenstich",
  "Achondroplasie",
  "Ballismus",
  "Chalazion",
  "Darmverschluss",
  "Eierstockkrebs",
  "Farbenblindheit",
  "Gastritis",
  "Hämangiom",
  "Insektenstiche",
  { value: "Karpaltunnelsyndrom", hasSides: true, area: "hand-{side}-bottom" },
  "Lassa-Fieber",
  "Magenkrebs",
  "Nagelpilz",
  "Oxyuriasis",
  "Paranoide Persönlichkeitsstörung",
  { value: "Raucherbein", hasSides: true, area: "leg-{side}-front" },
  { value: "Schädel-Hirn-Trauma", area: "head-front" },
  "Tetanus",
  "Uveitis",
  "Vena-cava-Syndrom",
  "Wernicke-Enzephalopathie",
  "Zervixinsuffizienz",
  "Acquired Immune Deficiency Syndrome",
  "Bänderdehnung",
  "Chikungunya",
  "Dekubitus",
  "Eierstockzyste",
  "Fatigue-Syndrom",
  "Gastroenteritis",
  { value: "Hammerzeh", hasSides: true, area: "foot-{side}-top" },
  "Katzenallergie",
  "Latexallergie",
  "Magenpolypen",
  "Narben",
  "Obere gastrointestinale Blutung",
  "Parkinson",
  "Raynaud-Syndrom",
  { value: "Schambeinentzündung", area: "torso-front" },
  "Thrombose",
  "Unspezifische Hypoglykämie",
  "Venenentzündung",
  "West-Nil-Fieber",
  "Zika-Virus-Infektion",
  "Addison Krankheit",
  "Bänderriss",
  "China-Restaurant-Syndrom",
  "Eileiterschwangerschaft",
  // "Fehlgeburt",
  "Gebärmutterhalskrebs",
  "Hämochromatose",
  { value: "Ischias", hasSides: true, area: "leg-{side}-back" },
  "Katzenbiss",
  "Läusebefall",
  { value: "Magenschleimhautentzündung", area: "torso-front" },
  "Narbenbruch",
  "Obstruktives Schlafapnoe-Syndrom",
  { value: "Parodontitis", area: "head-front" },
  "RDS",
  "Scharlach (Scarlatina)",
  "Thyreoiditis",
  "Unspezifische depressive Episode",
  "Veneninsuffizienz",
  "Windeldermatitis",
  "Zöliakie",
  "Bandruptur",
  "Chinesischer Leberegel",
  "Dengue-Fieber",
  {
    value: "Eingewachsener Zehennagel",
    hasSides: true,
    area: "foot-{side}-top",
  },
  { value: "Fersensporn", hasSides: true, area: "foot-{side}-back" },
  "Gebärmutterkrebs",
  "Hämophilie",
  { value: "ISG-Syndrom", area: "torso-back" },
  "Katzenkratzkrankheit",
  "Lebensmittelallergie",
  "Magersucht",
  "Narkolepsie",
  "Offenwinkelglaukom",
  "PCO-Syndrom",
  "Reaktive Arthritis (Morbus Reiter)",
  { value: "Scheidenentzündung", area: "torso-front" },
  "Tollwut",
  "Untere gastrointestinale Blutung",
  "Venenschwäche",
  "Windpocken",
  "Zuckerkrankheit",
  "Adipositas",
  { value: "Bandscheibenvorfall", area: "torso-back" },
  "Chlamydien-Infektion",
  "Depersonalisation",
  "Endokarditis",
  "Fettleber",
  { value: "Gebärmuttersenkung", area: "torso-front" },
  "Hämorrhoiden",
  "Kawasaki-Syndrom",
  "Lebensmittelvergiftung",
  "Makuladegeneration",
  "Narzisstische Persönlichkeitsstörung",
  "Oropharynxkarzinom",
  "Penispilz",
  "Refluxkrankheit",
  "Scheidenkrebs",
  "Tourette-Syndrom",
  "Verbrennung",
  { value: "Wirbelblockade", area: "torso-back" },
  "Zwangsstörung",
  "Akne",
  "Bartholinitis",
  "Cholangiozelluläres Karzinom",
  "Endometriose",
  "Fibroadenom",
  "Gelbfieber",
  "Hand-Fuß-Mund-Krankheit",
  "Hand-Fuss-Mund-Krankheit",
  "Infantile Kolik",
  { value: "Kehlkopfentzündung", area: "head-front" },
  "Leberkrebs",
  "Malaria",
  { value: "Nasennebenhöhlenentzündung", area: "head-front" },
  "Osteoporose",
  "Penisverkrümmung",
  "Reisekrankheit",
  { value: "Scheidenpilz", area: "torso-front" },
  "Toxoplasmose",
  "Vogelgrippe",
  "Wochenbettdepression",
  { value: "Zwerchfellbruch", area: "torso-front" },
  "Akute Belastungsreaktion",
  { value: "Bauchfellentzündung", area: "torso-front" },
  "Cholangitis",
  "Dermatomyositis",
  "Enzephalitis",
  "Fibrom",
  "Gelenkverschleiß",
  "Gelenkverschleiss",
  { value: "Harnröhrenverengung", area: "torso-front" },
  "Infektiöse Endokarditis",
  "Kehlkopfkrebs",
  "Lebermetastasen",
  { value: "Mandelentzündung", area: "head-front" },
  "Nasenpolypen",
  "Otitis externa",
  "Periorale Dermatitis",
  "Reizblase",
  "Scheidenriss",
  "Trigeminusneuralgie",
  "Virale Gastroenteritis",
  "Wundheilungsstörung",
  "Zyste am Eierstock",
  "Alkoholismus",
  { value: "Bauchnabelentzündung", area: "torso-front" },
  "Cholelithiasis",
  "Diabetes mellitus",
  "Epididymitis",
  "Fibromyalgie",
  "Generalisierte Angststörung",
  { value: "Harnwegsinfektion", area: "torso-front" },
  "Influenza",
  "Keloid",
  "Leberversagen",
  "Mandelsteine",
  { value: "Nebenhodenentzündung", area: "torso-front" },
  "Ösophaguskarzinom",
  "Pest",
  "Reizdarm",
  "Schenkelhernie",
  "Tripper",
  "Virale Konjunktivitis",
  "Wundrose",
  "Zysten",
  "Alkoholvergiftung",
  "Bauchspeicheldrüsenentzündung",
  "Cholera",
  "Diphallie",
  "Epigastrische Hernie",
  "Fibröse Dysplasie",
  "Geräuschüberempfindlichkeit (Hyperakusis)",
  "Hausstauballergie",
  "Inguinalhernie",
  "Kephalhämatom",
  "Leberzirrhose",
  "Manie",
  "Nephrolithiasis",
  "Pfeiffersches Drüsenfieber",
  "Rektusdiastase",
  "Schilddrüsenentzündung",
  "Trisomie 18",
  "Virale Meningitis",
  "Wundstarrkrampf",
  "Zytomegalie",
  "Alpha-1-Antitrypsin-Mangel",
  "Bauchspeicheldrüsenkrebs",
  "Chondropathie",
  "Diphtherie",
  "Epiglottitis",
  "Filariose",
  "Gerstenkorn",
  "Hautkrebs",
  "Instabile Angina pectoris",
  "Keratitis",
  "Legasthenie",
  "Marfan-Syndrom",
  "Nephropathie",
  "Phäochromozytom",
  { value: "Restless Legs", hasSides: true, area: "leg-{side}-front" },
  "Schilddrüsenkrebs",
  "Tuberkulose",
  "Virale Sinusitis",
  "Warze",
  "Zervixkarzinom",
  "ALS-Krankheit",
  "Benigne Prostatahyperplasie",
  "Chorea Huntington",
  "Diskusprolaps",
  "Epilepsie",
  "Fleckfieber",
  "Giardiasis",
  "Hautpilz",
  "Ischämischer Schlaganfall",
  "Keuchhusten",
  "Legionärskrankheit",
  "Masern",
  "Nephrotisches Syndrom",
  "Phenylketonurie",
  "Retinitis pigmentosa",
  "Schilddrüsenüberfunktion",
  "Typhus",
  "Vorzeitige Wehen",
  "Windeldermatitis",
  "Zervizitis",
  "Alveolitis",
  "Bilharziose",
  "chronische Polyarthritis",
  "Dissoziale Persönlichkeitsstörung",
  "Erkältung",
  "Flugangst",
  "Gicht",
  "Hepatitis",
  "Kleienpilzflechte",
  "Leishmaniose",
  "Mastitis",
  "Nesselsucht",
  "Phimose",
  "Retinopathia pigmentosa",
  "Schilddrüsenunterfunktion",
  "Tetanus",
  "Vulvovaginitis candidomycetica",
  "Zwangsstörung",
  "Alzheimer",
  { value: "Bindehautentzündung", area: "head-front" },
  "Chronisches Erschöpfungssyndrom",
  "Dissoziative Störung",
  "Erysipel",
  "Fraktur",
  { value: "Glaskörpertrübung", area: "head-front" },
  "Herpes",
  "Kleinwüchsigkeit",
  { value: "Leistenbruch", area: "torso-front" },
  "Mastoiditis",
  { value: "Netzhautablösung", area: "head-front" },
  "Phobien",
  "Reye-Syndrom",
  "Thermische Verletzung",
  "Zystische Fibrose",
  "Amaurosis",
  "Binge-Eating",
  "Cluster-Kopfschmerz",
  "Distorsion",
  { value: "Ebola-Virus-Infektion", area: "head-front" },
  { value: "Frozen Shoulder", hasSides: true, area: "arm-{side}-front" },
  "Glutenunverträglichkeit",
  "Herpes Zoster",
  { value: "Klumpfuß", hasSides: true, area: "foot-{side}-top" },
  { value: "Klumpfuss", hasSides: true, area: "foot-{side}-top" },
  "Lepra",
  { value: "Mausarm", hasSides: true, area: "arm-{side}-front" },
  "Neurodermitis",
  "Pica-Syndrom",
  "Rheumatoide Arthritis",
  "Tonsillitis",
  "Zöliakie",
  "Amöbenruhr",
  "CMD",
  "Divertikulitis",
  "Eisenmangelanämie",
  "Fruktoseintoleranz",
  "Gonorrhoe",
  { value: "Herzbeutelentzündung", area: "torso-front" },
  "Knochenbruch",
  "Leukämie",
  { value: "Medikamenteninduzierter Kopfschmerz", area: "head-front" },
  "Neurofibromatose",
  "Pilzvergiftung",
  "Ringelröteln",
  "Schlaganfall",
  "Transitorische ischämische Attacke",
  "Amyotrophe Lateralsklerose",
  "Bisswunden",
  "Colitis ulcerosa",
  "Down-Syndrom",
  "Endometriose",
  "FSME",
  "Granulomatose mit Polyangiitis (Morbus Wegener)",
  "Herzinfarkt",
  "Knochenentzündung",
  "Lichen sclerosus",
  "Nickelallergie",
  "Pityriasis versicolor",
  { value: "Rippenfellentzündung", area: "torso-front" },
  "Schleimbeutelentzündung",
  "Trichomoniasis",
  "Analfissur",
  "Blasenkrebs",
  "Conn-Syndrom",
  "Drei-Tage-Fieber",
  "Endometriumkarzinom",
  "Funikuläre Myelose",
  { value: "Grauer Star", area: "head-front" },
  { value: "Herzinsuffizienz", area: "torso-front" },
  "Knochenkrebs",
  "Lipom",
  "Meningitis",
  "Niedriger Blutdruck",
  "Plantarfasziitis",
  "Rosacea",
  "Schuppenflechte",
  "Trigeminusneuralgie",
  "Analprolaps",
  "Blasensteine",
  "COPD",
  "Druckgeschwür",
  { value: "Entzündliche Beckenerkrankung", area: "torso-front" },
  "Furunkel",
  "Grippe",
  { value: "Herzklappenfehler", area: "torso-front" },
  "Kolpitis",
  { value: "Meniskusriss", hasSides: true, area: "leg-{side}-front" },
  "Nierenarterienstenose",
  "Plasmozytom",
  "Rot-Grün-Schwäche",
  "Schuppenflechte (Psoriasis)",
  "Anaphylaktischer Schock",
  "Blepharitis",
  "Cor pulmonale",
  { value: "Dupuytren-Kontraktur", hasSides: true, area: "hand-{side}-bottom" },
  "Erkältung",
  { value: "Fußpilz", hasSides: true, area: "foot-{side}-top" },
  { value: "Fusspilz", hasSides: true, area: "foot-{side}-top" },
  { value: "Grüner Star", area: "head-front" },
  { value: "Herzmuskelentzündung", area: "torso-front" },
  "Kontaktallergie",
  "Listeriose",
  "Mesotheliom",
  { value: "Nierenentzündung", area: "torso-back" },
  { value: "Plattfuß", hasSides: true, area: "foot-{side}-top" },
  { value: "Plattfuss", hasSides: true, area: "foot-{side}-top" },
  "Rotavirus",
  "Schwangerschaftsvergiftung",
  "Aneurysma",
  { value: "Blinddarmentzündung", area: "torso-front" },
  "Corona-Impfungen: Nebenwirkungen",
  "Dyskalkulie",
  "Essentielle Hypertonie",
  // "Fehlgeburt",
  "Guillain-Barré-Syndrom",
  { value: "Herzneurose", area: "torso-front" },
  { value: "Koronare Herzkrankheit", area: "torso-front" },
  { value: "Lungenembolie", area: "torso-front" },
  "Metabolisches Syndrom",
  { value: "Niereninfarkt", area: "torso-back" },
  "Plazenta praevia",
  "Röteln",
  "Schweinegrippe",
  "Angelman-Syndrom",
  "Bluterkrankheit",
  "Covid-19: Infektion mit dem Coronavirus",
  "Dysmorphophobie",
  "Essentieller Tremor",
  "Fetales Alkoholsyndrom",
  "Gürtelrose",
  { value: "Herzrhythmusstörungen", area: "torso-front" },
  "Korsakow-Syndrom",
  "Lungenemphysem",
  { value: "Migräne", area: "head-front" },
  "Niereninsuffizienz",
  "Plazentainsuffizienz",
  "RS-Virus",
  "Seborrhoische Dermatitis",
  "Angina pectoris",
  "Bluthochdruck",
  "Dekubitus",
  "Exanthema subitum",
  "Fibromyalgie",
  "Gynäkomastie",
  { value: "Herzschwäche", area: "torso-front" },
  "Krampfadern",
  { value: "Lungenentzündung", area: "torso-front" },
  "Milchschorf",
  "Nierenkrebs",
  // "Plötzlicher Herztod",
  "Rachitis",
  "Seborrhoisches Ekzem",
  "Ankylosierende Spondylitis: AS",
  "Blutkrebs",
  "Creutzfeldt-Jakob-Krankheit",
  "Denguefieber",
  "Extrauteringravidität",
  "Fibrozystische Mastopathie",
  "Gallenblasenkarzinom",
  "Heuschnupfen",
  "Krätze",
  "Lungenfibrose",
  "Milzbrand",
  "Nierensteine",
  // "Plötzlicher Kindstod",
  "Reaktive Arthritis",
  "Sehnenriss",
  "Anpassungsstörung",
  "Blutvergiftung",
  "Chiragra",
  "Dentalabszess",
  "Fieberkrampf",
  "Gastroduodenale Ulkuskrankheit",
  { value: "Hirnblutung", area: "head-front" },
  "Lungenkrebs",
  { value: "Milzriss", area: "torso-front" },
  { value: "Nierenversagen, Nierenschwäche", area: "torso-front" },
  "PMS",
  "Reizdarmsyndrom",
  "Sehnenruptur",
  "Anthrax",
  "Borderline-Syndrom",
  "Chlamydieninfektion des Urogenitaltraktes",
  "Depression im Kindes- oder Jugendalter",
  "Fremdkörperaspiration",
  "Gastroösophageale Refluxkrankheit",
  { value: "Hirnhautentzündung", area: "head-front" },
  "Kreuzallergie",
  "Lupus erythematodes",
  "Mitochondriopathie",
  "Nikotinsucht",
  "Pneumothorax",
  { value: "Restless-Legs-Syndrom", hasSides: true, area: "leg-{side}-front" },
  "Sehnenscheidenentzündung",
  "Aortenklappenstenose",
  "Bornavirus-Infektion",
  "Cholezystitis",
  "Diabetes insipidus",
  "Fremdkörperingestion",
  { value: "Gehirnerschütterung", area: "head-front" },
  // "Hirntod",
  "Kuhmilchallergie",
  "Luxation",
  "Morbus Addison",
  "Norovirus",
  "Pocken",
  "Rheumatisches Fieber",
  "Sehnerventzündung",
  "Arteriitis temporalis (Riesenzellarteriitis)",
  "Borreliose",
  { value: "Chronische Beckenschmerzen", area: "torso-front" },
  "Diabetes mellitus Typ 2",
  "Früh disseminierte Lyme-Borreliose",
  "Hirntumor",
  "Kurzsichtigkeit",
  "Lymphdrüsenkrebs",
  "Morbus Bechterew",
  "Nahrungsmittelallergie",
  "Polio",
  "Rheumatoide Arthritis",
  { value: "Seitenstrangangina", area: "head-front" },
  "Arteriosklerose",
  "Botulismus",
  "Chronische Bronchitis",
  "Diffuses Kontaktekzem",
  "Frühe lokalisierte Lyme-Borreliose",
  "Generalisierter Krampfanfall",
  "Histaminintoleranz",
  "Lymphödem",
  "Morbus Crohn",
  "Nephritisches Syndrom",
  "Poliomyelitis, Kinderlähmung",
  "Rubella",
  // "Sekundentod",
  "Arthrose",
  "Boutonneuse-Fieber",
  "Chronische Gastritis",
  "Disseminierte Tuberkulose",
  "Funktionelle Dyspepsie",
  "Genitalwarzen",
  "Hitzschlag",
  "Keratokonjunktivitis sicca",
  "Larynxkarzinom",
  "Morbus Cushing",
  "Nephrolithiasis",
  "Polyneuropathie",
  { value: "Sexualkopfschmerz", area: "head-front" },
  "Arzneimittelexanthem",
  "Bronchiektasen",
  "Chronische Herzinsuffizienz",
  "Divertikulitis",
  "Gicht",
  "HIV-Infektion und AIDS",
  "Kleinzelliges Bronchialkarzinom",
  "Leberzirrhose",
  "Morbus Menière",
  "Nephrotisches Syndrom",
  "Porphyrie",
  "Sinusitis",
  "Asperger-Syndrom",
  "Brucellose",
  "Chronische Laryngitis",
  "Gonorrhö",
  "Hodenentzündung",
  "Kolorektales Karzinom",
  "Legionärskrankheit",
  "Morbus Meulengracht",
  "Nicht allergische Rhinitis",
  "Postnukleotomiesyndrom",
  "Sjögren-Syndrom",
  "Aspergillose",
  { value: "Brustkrebs", area: "torso-front" },
  "Chronisches Nierenversagen",
  "Hodenhochstand",
  "Konversionsstörung",
  "Lewy-Body-Demenz",
  "Morbus Osler",
  "Nicht näher spezifizierte Gedeihstörung",
  "Posttraumatische Belastungsstörung",
  "Skabies",
  "Asthma",
  "Bulimie",
  "Cluster-Kopfschmerz",
  "Hodenkrebs",
  "Kryptorchismus",
  "Lungenembolie",
  "Morbus Paget",
  "Nicht-kleinzelliges Bronchialkarzinom",
  "Prader-Willi-Syndrom",
  "Somatoforme Störung",
  "Astigmatismus",
  "Colitis ulcerosa",
  "Hodentorsion",
  "Morbus Parkinson",
  "Prämenstruelles Syndrom",
  "Sonnenallergie",
  "Atelektase",
  { value: "Bagatelltrauma am Kopf", area: "head-front" },
  "Cushing-Syndrom",
  "Hordeolum",
  "Morbus Scheuermann",
  "Prellung",
  "Sonnenbrand",
  "Atherom",
  "Bakterielle Konjunktivitis",
  "Cytomegalovirus-Infektion",
  "Hornhautentzündung",
  "Morbus Sudeck",
  "Proktitis",
  "Sonnenstich",
  "Autismus",
  "Bakterielle Meningitis",
  "Hornhautverkrümmung",
  "Morbus Wilson",
  "Prolaktinom",
  "Soor",
  "Abakterielle Prostatitis",
  "Bakterielle Prostatitis",
  "HPV",
  "MS",
  "Prostatakrebs",
  "Sorbitunverträglichkeit",
  "Absence-Epilepsie des Kindesalters",
  "Bakterielle Sinusitis",
  "Hufeisenniere",
  "Mukoviszidose",
  "Prostatitis",
  { value: "Spannungskopfschmerz", area: "head-front" },
  {
    value: "Achillessehnentendinitis/-entzündung",
    hasSides: true,
    area: "foot-{side}-back",
  },
  "Bakterielle Vaginose",
  { value: "Hüftdysplasie", area: "torso-front" },
  "Multiple Sklerose",
  "Proteus-Syndrom",
  "Speiseröhrenkrebs",
  "Acne vulgaris",
  "Benigne Prostatahyperplasie",
  "Hühnerauge",
  "Mumps",
  "Pseudokrupp",
  "Spielsucht",
  "Akute Appendizitis",
  "Benigner paroxysmaler Lagerungsschwindel",
  "Hundeallergie",
  "Münchhausen-Syndrom",
  "Spinale Muskelatrophie",
  "Akute Aspiration von Oropharynx- und Mageninhalt",
  "Bipolare affektive Störung",
  "Hundebiss",
  "Muskelfaserriss",
  "Pudendusneuralgie",
  "Spinalkanalstenose",
  "Akute Bronchitis",
  "Borderline-Persönlichkeitsstörung",
  "Hydrozele",
  "Muskelzerrung",
  "Pulmonale Hypertonie",
  "Splenomegalie",
  "Akute Gastritis",
  "Hypercholesterinämie",
  "Myasthenia gravis",
  "Pylorusstenose",
  "Spondylolisthesis",
  "Akute HIV-Infektion",
  "Hyperopie",
  "Myelodysplastisches Syndrom",
  "Pankreaskarzinom",
  "Spulwürmer",
  "Akute Herzinsuffizienz",
  "Hyperthyreose",
  "Myom",
  "Perimenopause",
  "Staublunge",
  "Akute Laryngitis",
  "Hypochondrie",
  "Myopie",
  "Periphere arterielle Verschlusskrankheit",
  "Steißbeinfistel",
  "Steissbeinfistel",
  "Akute Otitis media",
  "Hypothyreose",
  "Magenkarzinom",
  "Pertussis",
  "Storchenbiss",
  "Akute Panikattacke",
  "Harnblasenkarzinom",
  "Mammakarzinom",
  "Pneumonie",
  "Strabismus",
  "Akute Pankreatitis",
  "Harnwegsinfekt",
  "Melanom",
  "Pneumothorax",
  "Stromschlag",
  "Akute Pharyngitis",
  "Hashimoto-Thyreoiditis",
  { value: "Migräne", area: "head-front" },
  "Podagra",
  "Subclavian-steal-Syndrom",
  "Akute Pyelonephritis",
  "Herpangina",
  "Morbus Crohn",
  "Poliovirusinfektion",
  "Syphilis",
  "Akute Varizella-Zoster-Virusinfektion",
  "Herpes genitalis",
  "Morbus Parkinson",
  "Polyartikuläre septische Arthritis",
  "Alkoholentzugssyndrom",
  "Herpes labialis",
  "Multiple Sklerose",
  "Polymyalgia rheumatica",
  "Schwangerschaft",
  "Alkoholintoxikation",
  "Herpes zoster ophthalmicus",
  "Multiples Myelom",
  "Polyzystisches Ovarialsyndrom",
  "Sekundäre Syphilis",
  "Allergische Konjunktivitis",
  "Herpes-Zoster-Infektion",
  "Mumps",
  "Postinfektiöse Glomerulonephritis",
  "Sepsis",
  "Allergische Rhinitis",
  "Hirnstamminfarkt",
  { value: "Muskuloskeletale Schmerzen im unteren Rücken", area: "torso-back" },
  "Posttraumatische Belastungsstörung",
  "Skabies",
  "Amyotrophe Lateralsklerose (ALS)",
  "Hodenkarzinom",
  "Myasthenia gravis",
  "Primäre Syphilis",
  { value: "Spannungskopfschmerzen", area: "head-front" },
  "Analfissur",
  "Hodentorsion",
  "Myokardinfarkt",
  "Prostatakarzinom",
  "Spätform der Lyme-Borreliose",
  "Analkarzinom",
  "Hypertensive Retinopathie",
  "Myokarditis",
  "Präeklampsie",
  "Subarachnoidalblutung",
  "Anaphylaxie",
  "Hypothermie",
  "Prämenstruelles Syndrom",
  {
    value: "Subluxation oder Luxation des Radiusköpfchens",
    hasSides: true,
    area: "arm-{side}-back",
  },
  { value: "Angeborene Hüftdysplasie", area: "torso-front" },
  "Hypothyreose",
  "Pädiatrische Harnwegsinfektion",
  { value: "Subluxation und Luxation des Hüftgelenks", area: "torso-front" },
  "Aortendissektion",
  "Hämophilie",
  "Pädiatrische Pneumonie",
  "Symptomatische Cholelithiasis",
  "Asthma bei Kindern",
  "Hämorrhagischer Schlaganfall",
  "Pädiatrische akute Otitis media",
  "Systemischer Lupus erythematodes",
  "Asthma bronchiale",
  "Hämorrhoiden",
  "Pädiatrische virale Gastroenteritis",
  "Atopische Dermatitis",
  "Atopische Dermatitis bei Kindern",
  "Atopisches Ekzem im Säuglingsalter",
  "Aufmerksamkeitsdefizit- und Hyperaktivitätsstörung",

  // Excel Spalte A -> X
  { value: "Zahn-/Kieferschmerzen / Zahnfleischentzündung", id: "X" },
  { value: "Kieferfehlstellung (Zahnregulierung)", id: "X" },
  { value: "Zahnersatz", id: "X", category: "Zahnersatz" },
  { value: "Festsitzender Zahnersatz", id: "X", category: "Zahnersatz" },
  { value: "Herausnehmbarer Zahnersatz", id: "X", category: "Zahnersatz" },
  { value: "Kombinierter Zahnersatz", id: "X", category: "Zahnersatz" },
  { value: "Zahn-Teilkrone", id: "X", category: "Zahnersatz" },
  { value: "Zahnkrone", id: "X", category: "Zahnersatz" },
  { value: "Brücke", id: "X", category: "Zahnersatz" },
  { value: "Zahnbrücke", id: "X", category: "Zahnersatz" },
  { value: "Implantat", id: "X", category: "Zahnersatz" },
  { value: "Zahnimplantat", id: "X", category: "Zahnersatz" },
  { value: "Vollprothese", id: "X", category: "Zahnersatz" },
  { value: "Teilprothese", id: "X", category: "Zahnersatz" },
  { value: "Klammerprothese", id: "X", category: "Zahnersatz" },
  { value: "Teleskopprothese", id: "X", category: "Zahnersatz" },
  { value: "Zahngeschiebeprothese", id: "X", category: "Zahnersatz" },
  { value: "Zahnklammerprothese", id: "X", category: "Zahnersatz" },
  { value: "Zahnteleskopprothese", id: "X", category: "Zahnersatz" },
  { value: "Zahnprothese", id: "X", category: "Zahnersatz" },
  { value: "Klebebrücke", id: "X", category: "Zahnersatz" },
  { value: "Zahnklebebrücke", id: "X", category: "Zahnersatz" },
  { value: "Primärkrone", id: "X", category: "Zahnersatz" },
  { value: "Sekundärkrone", id: "X", category: "Zahnersatz" },
  { value: "Zahnsekundärkrone", id: "X", category: "Zahnersatz" },
  { value: "Zahnprimärkrone", id: "X", category: "Zahnersatz" },
  { value: "Innenteleskop", id: "X", category: "Zahnersatz" },
  { value: "Außenteleskop", id: "X", category: "Zahnersatz" },
  { value: "Aussenteleskop", id: "X", category: "Zahnersatz" },
  { value: "Zahninnenteleskop", id: "X", category: "Zahnersatz" },
  { value: "Zahnaußenteleskop", id: "X", category: "Zahnersatz" },
  { value: "Zahnaussenteleskop", id: "X", category: "Zahnersatz" },
  {
    value: "Sonstige Beschwerden (Mundgeruch, Angst vorm Zahnarzt, etc.)",
    id: "X",
  },
  { value: "Zahnfleischentzündung (Gingivitis)", id: "X" },
  { value: "Karies", id: "X" },
  { value: "Zahnwurzelentzündung (apikale Parodontitis)", id: "X" },
  { value: "Kreidezähne", id: "X" },

  // Diagnosen zahnDiagnosen.js
  { value: "Prothese", id: "X", category: "Zahnersatz" },
  { value: "Zahnregulierung", id: "X" },
  { value: "Wurzelbehandlung", id: "X" },
  { value: "Chirurgische OP", id: "X" },
  { value: "Zahnfüllung", id: "X" },
  { value: "Keramikfüllung", id: "X" },
  { value: "Goldfüllung", id: "X" },
  { value: "Inlays", id: "X" },
  { value: "Kunststoff", id: "X" },
  { value: "Chrirurgische Behandlung", id: "X" },
  { value: "Krone", id: "X", category: "Zahnersatz" },
  { value: "Zahnspange", id: "X" },
  { value: "Kieferbruch", id: "X" },
  { value: "Zahnausfall", id: "X" },

  // Diagnosen mental/psychisch
  { value: "ADHS", id: "mental" },
  { value: "Adipositas (Fettsucht)", id: "mental" },
  { value: "Albträume", id: "mental" },
  { value: "Anorexia nervosa (Magersucht)", id: "mental" },
  { value: "Anspannung (Nervosität und Unruhe)", id: "mental" },
  { value: "Aufmerksamkeitsdefizit-Hyperaktivitätsstörung", id: "mental" },
  { value: "BED (Binge Eating Disorder)", id: "mental" },
  { value: "Beine, ruhelose (RLS)", id: "mental" },
  { value: "Bipolare Störung", id: "mental" },
  { value: "Bulimie (Ess-Brech-Sucht)", id: "mental" },
  { value: "Burnout", id: "mental" },
  { value: "Cardiophobie (Herzneurose)", id: "mental" },
  { value: "Da Costa-Syndrom (Herzneurose)", id: "mental" },
  { value: "Depression", id: "mental" },
  { value: "Depression bei Parkinson", id: "mental" },
  { value: "Depressive Störungen (depressive Verstimmungen)", id: "mental" },
  { value: "Dysthymie", id: "mental" },
  { value: "Effort-Syndrom (Herzneurose)", id: "mental" },
  { value: "Erschöpfungssyndrom", id: "mental" },
  { value: "Ess-Brech-Sucht (Bulimie)", id: "mental" },
  { value: "Essstörungen", id: "mental" },
  { value: "Esssucht (Binge Eating Disorder)", id: "mental" },
  { value: "Fettsucht (Adipositas)", id: "mental" },
  { value: "Foramen ovale persistens (Herzneurose)", id: "mental" },
  { value: "Fresssucht (Binge Eating Disorder)", id: "mental" },
  { value: "Heißhungeranfälle (Binge Eating)", id: "mental" },
  { value: "Heisshungeranfälle (Binge Eating)", id: "mental" },
  { value: "Herzangst-Syndrom (Herzneurose)", id: "mental" },
  { value: "Herzneurose (Herzphobie)", id: "mental" },
  { value: "Hypersomnie", id: "mental" },
  { value: "Insomnie (Schlaflosigkeit)", id: "mental" },
  { value: "Magersucht (Anorexia nervosa)", id: "mental" },
  { value: "Major Depression", id: "mental" },
  { value: "Manisch-depressive Störung (Bipolare Störung)", id: "mental" },
  { value: "Nachtmahr (Albträume)", id: "mental" },
  { value: "Nachtwandeln (Schlafwandeln)", id: "mental" },
  { value: "Narkolepsie (Schlummersucht)", id: "mental" },
  { value: "Neurozirkulatorische Asthenie", id: "mental" },
  { value: "Niedergeschlagenheit (depressive Verstimmungen)", id: "mental" },
  { value: "Obesitas (Adipositas)", id: "mental" },
  { value: "Orthorexie (Orthorexia nervosa)", id: "mental" },
  { value: "Panik ", id: "mental" },
  { value: "Angst ", id: "mental" },
  { value: "Phobie", id: "mental" },
  { value: "Parasomnie", id: "mental" },
  { value: "Pflegende Angehörige, Burnout-Selbsttest", id: "mental" },
  { value: "Pica-Syndrom (Pikazismus)", id: "mental" },
  { value: "post stroke depression (Depression)", id: "mental" },
  { value: "Psychogene Essstörungen", id: "mental" },
  { value: "Psychogene Magersucht (Anorexie)", id: "mental" },
  { value: "Reaktive Depression", id: "mental" },
  { value: "Restless-Legs-Syndrom (RLS)", id: "mental" },
  { value: "Schizophrenie", id: "mental" },
  { value: "Schlafapnoe", id: "mental" },
  { value: "Schlaflosigkeit (Insomnie)", id: "mental" },
  { value: "Schlafstörungen", id: "mental" },
  { value: "Schlafwandeln (Somnambulismus)", id: "mental" },
  { value: "Schlummersucht (Narkolepsie)", id: "mental" },
  { value: "Schwindel (Vertigo)", id: "mental" },
  { value: "Somnambulismus (Schlafwandeln)", id: "mental" },
  { value: "Stimmungsschwankungen während der Schwangerschaft", id: "mental" },
  { value: "Stresszustände (Nervosität und Unruhe)", id: "mental" },
  { value: "Übergewicht (Adipositas)", id: "mental" },
  { value: "Vergesslichkeit im Alter", id: "mental" },
  { value: "Zwangserkrankungen", id: "mental" },
  { value: "Zyklothymie", id: "mental" },
  { value: "Angststörung", id: "mental" },
  { value: "ADHS Erwachsene", id: "mental" },
  { value: "Alkoholsucht", id: "mental" },
  { value: "Co-Abhängigkeit", id: "mental" },
  { value: "Demenz", id: "mental" },
  { value: "Dissoziative Störungen", id: "mental" },
  { value: "Internetsucht", id: "mental" },
  { value: "Kinder und Jugendliche", id: "mental" },
  { value: "Medikamentensucht", id: "mental" },
  { value: "Narzissmus", id: "mental" },
  { value: "Persönlichkeitsstörungen", id: "mental" },
  { value: "Psychische Störungen im Alter", id: "mental" },
  { value: "Psychoonkologie", id: "mental" },
  { value: "Suizid", id: "mental" },
  { value: "Trauma", id: "mental" },
  { value: "Winterdepression", id: "mental" },
  { value: "Zwang", id: "mental" },
  { value: "Psychose", id: "mental" },
  { value: "Fehlgeburt", id: "mental" },
  { value: "Kind verloren", id: "mental" },
  { value: "Abtreibung", id: "mental" },

  // Kieferorthopädische Krankheitsbilder_07_07_2021
  { value: "Schmalkiefer", id: "kiefer" },
  { value: "Distalbiss", id: "kiefer" },
  { value: "Distale Bisslage", id: "kiefer" },
  { value: "Mesiale Bisslage", id: "kiefer" },
  { value: "Mesialbiss", id: "kiefer" },
  { value: "Offener Biss", id: "kiefer" },
  { value: "Tiefbiss", id: "kiefer" },
  { value: "Deckbiss", id: "kiefer" },
  { value: "Tief-/Deckbiss", id: "kiefer" },
  { value: "Kreuzbiss", id: "kiefer" },
  { value: "Beidseitiger Kreuzbiss", id: "kiefer" },
  { value: "Platzmangel", id: "kiefer" },
  { value: "Engstand", id: "kiefer" },
  { value: "Engstand der Zähne", id: "kiefer" },
  { value: "Hyperdontie", id: "kiefer" },
  { value: "Dysgnathie", id: "kiefer" },
  { value: "Kieferknacken", id: "kiefer" },
  { value: "Progene Verzahnung", id: "kiefer" },
  { value: "Bukkalokklusion / Laterognathien", id: "kiefer" },
  { value: "Platzüberschuss", id: "kiefer" },
  { value: "Nichtanlagen", id: "kiefer" },
  { value: "Retention und Verlagerung von Zähnen", id: "kiefer" },
  { value: "Lippen-Kiefer-Gaumenspalte", id: "kiefer" },
  { value: "Zahnschiefstellung", id: "kiefer" },
  { value: "Zahnfehlstellung", id: "kiefer" },
  { value: "Kieferfehlstellung", id: "kiefer" },
  { value: "Craniomandibuläre Dysfunktion (CMD)", id: "kiefer" },
  { value: "Zahnunterzahl", id: "kiefer" },
  { value: "Dentitionsstörungen", id: "kiefer" },
  { value: "Bukkal-/Lingualokklusion", id: "kiefer" },
  { value: "Bukkalokklusion", id: "kiefer" },
  { value: "Lingualokklusion", id: "kiefer" },

  // Diagnosen Joachim Mail 31.08.2021
  { value: "Gehirntumor", id: "kopf" },
  { value: "Gehirntumore", id: "kopf" },
  { value: "Neuropathie", id: "kopf" },
  { value: "Ataxi", id: "kopf" },
  { value: "Synästhesie", id: "kopf" },

  { value: "Zervikale Spondylose", id: "nacken" },
  { value: "Zervikale Spinalkanalstenose", id: "nacken" },

  { value: "Rotatorenmanschettenruptur", id: "schulter" },
  { value: "Kalkschulter", id: "schulter" },
  { value: "Schultersteife (Adhäsive Kapsulitis)", id: "schulter" },
  { value: "Subluxation und Luxation der Schulter", id: "schulter" },
  { value: "Subluxation oder Luxation der Schulter", id: "schulter" },
  { value: "SLAP Läsion", id: "schulter" },
  { value: "AC Gelenksinstabilität (Schultereckgelenk)", id: "schulter" },
  { value: "Omarthrose (Arthrose des Schultergelenkes)", id: "schulter" },
  { value: "Frozen Shoulder (Schultersteife)", id: "schulter" },

  { value: "Hexenschuss", id: "ruecken" },
  { value: "Iliosakralgelenksyndrom (ISG-Syndrom)", id: "ruecken" },
  { value: "Skoliose", id: "ruecken" },
  { value: "Kostotransversalgelenk - Syndrom", id: "ruecken" },

  { value: "Galaktorrhoe", id: "brust" },

  { value: "RSI-Syndrom – Mausarm durch Computer", id: "arm" },
  { value: "Ganglionzyste", id: "arm" },
  { value: "Trommelschlägelfinger", id: "arm" },

  { value: "Funktionelle Störungen des Magen-Darm-Traktes", id: "bauch" },
  {
    value: "Entzündung der Speiseröhrenschleimhaut (Ösophagitis)",
    id: "bauch",
  },
  { value: "Entzündung der Magenschleimhaut (Gastritits)", id: "bauch" },
  { value: "Schleimhautdefekt von der Speiseröhre", id: "bauch" },
  { value: "Schleimhautdefekt vom Magen", id: "bauch" },
  { value: "Schleimhautdefekt vom Zwölffingerdarm", id: "bauch" },
  { value: "Schleimhautdefekt vom Darm", id: "bauch" },
  { value: "Blinddarmentzündung (Appendizitis)", id: "bauch" },
  { value: "Entzündung des Dünndarms (Enteritis)", id: "bauch" },
  { value: "Entzündung des Enddarms (Proktitis)", id: "bauch" },
  { value: "Entzündung des Dickdarms (Kolitis)", id: "bauch" },
  { value: "Entzündung der Leber (Hepatitis)", id: "bauch" },
  { value: "Harnblasenentzündung", id: "bauch" },

  { value: "Eileiterentzündung und Eierstockentzündung", id: "geschlecht" },
  { value: "Eierstockentzündung", id: "geschlecht" },
  { value: "Eileiterentzündung", id: "geschlecht" },
  { value: "Erektionsstörung (Erektile Dysfunktion)", id: "geschlecht" },
  { value: "Hodenverdrehung (Hodentorsion)", id: "geschlecht" },
  { value: "Peniskrebs", id: "geschlecht" },
  { value: "Unfruchtbarkeit", id: "geschlecht" },
  { value: "Vorhautverengung (Phimos)", id: "geschlecht" },

  { value: "Arthrose des Hüftgelenks (Coxarthrose)", id: "huefte" },
  { value: "Hüftkopfnekrose", id: "huefte" },

  {
    value: "Besenreiser",
    id: "bein",
    hasSides: true,
    area: "leg-{side}-front",
  },
  {
    value: "Wasser in den Beinen",
    id: "bein",
    hasSides: true,
    area: "leg-{side}-front",
  },
  {
    value: "Knorpelschaden im Kniegelenk",
    id: "bein",
    hasSides: true,
    area: "leg-{side}-front",
  },
  {
    value: "Knorpelschaden im Sprunggelenk",
    id: "bein",
    hasSides: true,
    area: "foot-{side}-top",
  },
  {
    value: "Kreuzbandriss",
    id: "bein",
    hasSides: true,
    area: "leg-{side}-front",
  },
  {
    value: "Miniskuseinriss",
    id: "bein",
    hasSides: true,
    area: "leg-{side}-front",
  },
  {
    value: "Patellaentzündung",
    id: "bein",
    hasSides: true,
    area: "leg-{side}-front",
  },
  { value: "Krallenzehe", id: "bein", hasSides: true, area: "foot-{side}-top" },
  {
    value: "Knick-Senk-Spreiz-Fuß",
    id: "bein",
    hasSides: true,
    area: "foot-{side}-top",
  },
  {
    value: "Knick-Senk-Spreiz-Fuss",
    id: "bein",
    hasSides: true,
    area: "foot-{side}-top",
  },
  { value: "Digitus quintus varus", id: "bein" },
  {
    value: "Haglundferse / Haglund - Exostose / Haglund - Syndrom",
    id: "bein",
    hasSides: true,
    area: "foot-{side}-back",
  },

  // Diagnosen Joachim Korrekturen Roodie_ARAG App_Erg Korrekturen_ab 2023-03-25 Folie 135
  { value: "Kieferzyste", id: "kiefer" },
  { value: "Zahnfleischschwund", id: "X" },
  { value: "Zahnmarkentzündung (Pulpitis)", id: "X" },
  { value: "Zähneknirschen (Bruxismus)", id: "X" },
  { value: "Entzündung um das Implantat (Periimplantitis)", id: "X" },
  { value: "Zahngranulome (Granuloma apicale)", id: "X" },

  // Ontologieergänzung Joachim Mail 15.02.2024 Folie 168
  { value: "Schwarze Haarzunge (Lingua villosa nigra)", id: "zunge" },
  { value: "Haarzunge (Lingua villosa)", id: "zunge" },
  { value: "Entzündung der Zunge (Glossitis rhombica mediana)", id: "zunge" },
  { value: "Lackzunge/Spiegelzunge (Lingua glabra)", id: "zunge" },
  { value: "Aphten ", id: "zunge" },
  { value: "Mundsoor (Candida albicans)", id: "zunge" },
  { value: "Erdbeer-/Himbeerzunge (Scharlach)", id: "zunge" },
  { value: "Speicheldrüsenretentionszyste", id: "zunge" },
  { value: "Zungenkarzinom", id: "zunge" },
  { value: "Cheilitis simplex (Lippenentzündung)", id: "lippen" },
  { value: "Mundwinkelrhagaden/Faulecken (Cheilitis angularis)", id: "lippen" },
  { value: "Cheilitis glandularis", id: "lippen" },
  { value: "Cheilitis glandularis purulenta", id: "lippen" },
  { value: "Cheilitis actinica", id: "lippen" },
  { value: "Cheilitis ekzematosa", id: "lippen" },
  { value: "Melkerson-Rosenthal (Cheilitis granulomatosa)", id: "lippen" },
  { value: "Pemphigus vulgaris", id: "haut" },
  { value: "Pemphigus vegetans", id: "haut" },
  { value: "Bullöses Pemphigoid", id: "haut" },
  { value: "Erythema exsudativum multiforme", id: "haut" },
  { value: "Lichen ruber planus", id: "haut" },
  { value: "Hyperkeratosen", id: "haut" },
  { value: "Granuloma gangraenescens (malignes Granulom)", id: "haut" },
  { value: "Papillom und Verruca vulgaris", id: "haut" },
  { value: "Herpes mucosae oris", id: "mund" },
  {
    value: "Mundfäule (Gingivostomatitis herpetica/Stomatitis aphthosa)",
    id: "mund",
  },
  { value: "oraler Lichen planus/lichenoide Reaktion", id: "mund" },
  { value: "Erythroplakie ", id: "mund" },
  { value: "Leukoplakie", id: "mund" },
  { value: "Cerumen obturans", id: "ohr" },
  { value: "Cholesteatom", id: "ohr" },
  { value: "Ohrendruck (Barotrauma)", id: "ohr" },
  { value: "Hörsturz (Ohrinfarkt)", id: "ohr" },
  { value: "Altersschwerhörigkeit (Presbyakusis)", id: "ohr" },
  { value: "Schalltrauma (Knalltrauma, Lärmtrauma)", id: "ohr" },
  { value: "Ohrgeräusche (Tinnitus)", id: "ohr" },
  { value: "Trommelfellperforation", id: "ohr" },
  { value: "Lagerungsschwindel", id: "ohr" },
  { value: "Usher-Syndrom", id: "ohr" },
];
